export const ROUTES = {
  root: '/',
  referralBuilder: (referralCode: string): string => `/${referralCode}`,
  referral: '/:referralCode',
  beforeWeBegin: '/before-we-begin',
  onboarding: {
    index: '/onboarding',
    whatBringsYou: '/onboarding/what-brings-you',
    drawHeart: '/onboarding/draw-heart',
    ocdThemesSelection: '/onboarding/ocd-themes-selection',
    ocdThemesDetailsSelect: '/onboarding/ocd-themes-details-select',
    ocdCycleIntro: '/onboarding/ocd-cycle-intro',
    ocdCycleExplain: '/onboarding/ocd-cycle-explain',
    personalizingOllie: '/onboarding/personalizing-ollie',
    register: '/onboarding/register',
    highFive: '/onboarding/high-five',
    rating: '/onboarding/rating',
    paywall: '/onboarding/paywall',
    goToAppStore: '/onboarding/go-to-app-store',
  },
} as const;

export type Routes = typeof ROUTES;
